import React, {Component} from "react";

class SimpleIcon extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <span>
                <i {...this.props} className={this.props.className}></i>
            </span>
        )
    }

}

export default SimpleIcon;